import { render, staticRenderFns } from "./navigation.vue?vue&type=template&id=1c353b5d&scoped=true&"
import script from "./navigation.vue?vue&type=script&lang=js&"
export * from "./navigation.vue?vue&type=script&lang=js&"
import style0 from "./navigation.vue?vue&type=style&index=0&id=1c353b5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c353b5d",
  null
  
)

export default component.exports